<template>
    <svg viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 3.4001L2 14.6001M7.8028 12.5L4.40002 9M4.40002 9L7.8028 5.5M4.40002 9L12.8 9" stroke="#060606" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19.3193 14V4.00586H20.9531V12.5986H25.1846V14H19.3193Z" fill="#060606"/>
    </svg>
</template>